import { useEffect, useState } from 'react';

import { API_BASE_URL } from '../config/config';
import { CommunicationClient } from '../services/apiClient';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

interface UseCommunicationLists {
  communicationLists: string[];
  isLoading: boolean;
  error: string | null;
}

const useCommunicationLists = (): UseCommunicationLists => {
  const [communicationLists, setCommunicationLists] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const communicationClient = new CommunicationClient(
    API_BASE_URL,
    axiosInstance,
  );

  useEffect(() => {
    const fetchCommunicationLists = async (): Promise<void> => {
      setIsLoading(true);
      try {
        const lists = await communicationClient.getAllCommunicationLists();
        if (lists && lists.success && lists.data) {
          setCommunicationLists(lists.data);
        } else {
          setError('Failed to fetch communication lists');
        }
      } catch (err: unknown) {
        handleHookError(err, 'Error fetching communication lists', setError);
        throw err;
      } finally {
        setIsLoading(false);
      }
    };

    fetchCommunicationLists();
  }, []);

  return { communicationLists, isLoading, error };
};

export default useCommunicationLists;
